import './ORDS.scss';
import {PageManager} from '@mvps-genesis/bootstrap';

export default class ORDS extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

}
